import { CSSObject } from '@chakra-ui/react';

export const DayHeading: CSSObject = {
  color: 'white',
};

export const PageHeadingWrapper: CSSObject = {
  borderColor: 'gray.200',
};

export const DownloadActionLink: CSSObject = {
  color: 'beta.500',
};

export const TransactionWrapper: CSSObject = {
  borderRadius: 'base',
  bg: 'white',
  borderBottom: 'none',
  mx: '2',
  p: '2',
  w: 'unset',
};

export const TableWrapper: CSSObject = {
  bg: 'gray.200',
  gap: '1',
  mx: '-2',
  width: 'unset',
};
